import React from "react";
import aboutHeroImage from "../Assets/images/busesbranding.png";
import OurStorySection from "\./OurStorySection";
import MissionVisionSection from "./MissionVisionSection";
import OurValuesSection from "./OurValuesSection";
import "./AboutUsPage.css";

const AboutUsPage = () => {
  return (
    <div className="staffline-about-page">

      {/* ===== HERO SECTION ===== */}
      <section
        className="staffline-about-hero"
        style={{ backgroundImage: `url(${aboutHeroImage})` }}
      >
        <div className="staffline-about-hero-overlay"></div>

        <div className="container staffline-about-hero-content">
          <span className="staffline-about-hero-tag">
            🚌 About StaffLine Transport
          </span>

          <h1 className="staffline-about-hero-title">
            Reliable Commuting for <span>Every Worker</span>
          </h1>

          <p className="staffline-about-hero-subtitle">
            We exist to end the daily stress of unreliable transport. StaffLine
            is a subscription-based staff shuttle service built for the modern
            Ghanaian workforce.
          </p>

          <div className="staffline-about-hero-stats">
            <div className="staffline-about-hero-stat">
              <strong>20+</strong>
              <span>Routes Available</span>
            </div>
            <div className="staffline-about-hero-stat">
              <strong>22</strong>
              <span>Seats Per Bus</span>
            </div>
            <div className="staffline-about-hero-stat">
              <strong>800</strong>
              <span>GHS / Month</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SECTION 1: OUR STORY (Problem + Solution + Video) ===== */}
      <OurStorySection />

      {/* ===== SECTION 2: MISSION & VISION ===== */}
      <MissionVisionSection />

      {/* ===== SECTION 3: OUR VALUES ===== */}
      <OurValuesSection />

      {/* ===== FINAL CTA ===== */}
      <section className="staffline-about-cta">
        <div className="container staffline-about-cta-content">
          <h2>Ready to Join the Movement?</h2>
          <p>
            Subscribe today and enjoy a guaranteed seat, fixed schedule, and a
            stress-free commute — every working day.
          </p>
          <div className="staffline-about-cta-actions">
            <a href="/subscription" className="staffline-about-cta-btn-primary">
              Subscribe Now
            </a>
            <a href="/contact-us" className="staffline-about-cta-btn-secondary">
              Contact Us
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutUsPage;